export default "__VITE_ASSET__Ky8$m3Hh__"